import {registerLocale, setDefaultLocale} from 'react-datepicker';

import nl from 'date-fns/locale/nl';
registerLocale('nl', nl);
setDefaultLocale('nl');
